import { render } from "./Coupon.vue?vue&type=template&id=32ecc5df&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=32ecc5df&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ecc5df"]])

export default __exports__